import { useState, useEffect } from "react";
import { fetchApprovalHistory, withdrawApproval } from "../../models/price-drawer/pricingModel";

export function useQuoteApprovalFlow({ card, open, userId, approvalDecidedTick, notify }) {
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [withdrawing, setWithdrawing] = useState(false);
  const [resubmitModalOpen, setResubmitModalOpen] = useState(false);
  const [resubmitReason, setResubmitReason] = useState("");
  const pendingApproval = approvalHistory.find(a => a.status === "pending") || null;

  const refreshApprovalHistory = () => {
    if (!card?.id) return;
    fetchApprovalHistory(card.id).then(list => { if (list) setApprovalHistory(list); });
  };

  // Refresh history when admin approves or rejects (socket tick from QuerysetV4)
  useEffect(() => {
    if (approvalDecidedTick > 0 && open) refreshApprovalHistory();
  }, [approvalDecidedTick]); // eslint-disable-line

  const handleWithdrawApproval = async () => {
    if (!pendingApproval) return;
    setWithdrawing(true);
    try {
      const res = await withdrawApproval(pendingApproval.id, userId);
      if (!res.success) throw new Error(res.message);
      setApprovalHistory(prev => prev.filter(a => a.id !== pendingApproval.id));
      notify.success("Approval request withdrawn");
    } catch (e) {
      notify.error(e?.response?.data?.message || e?.message || "Failed to withdraw approval request");
    } finally {
      setWithdrawing(false);
    }
  };


  return { approvalHistory, setApprovalHistory, withdrawing, pendingApproval, resubmitModalOpen, setResubmitModalOpen, resubmitReason, setResubmitReason, refreshApprovalHistory, handleWithdrawApproval };
}

export function useQuoteReviewCorrection({ getPricingKey, setManualShare, onStalePricing, setTextManuallyEdited, notify }) {
  const [reviewCorrection, setReviewCorrection] = useState(null);
  const [pricingNotice, setPricingNotice] = useState('');
  const receiveReview = failure => {
    const review = failure?.response?.data?.data?.pricing_review;
    if (!review?.parts) {
      if (failure?.response?.status === 409) {
        notify.warning(`${failure.response.data?.message || "Quote data changed."} Reloading the supplier quotes. Review the prices and open Share quote again.`);
        setManualShare(null); onStalePricing?.();
        return true;
      }
      return false;
    }
    setReviewCorrection({ key: getPricingKey(), review });
    setPricingNotice('Pricing changed on the server. The displayed prices have been refreshed. Review the parts and message, then submit again.');
    setTextManuallyEdited(false); setManualShare(null);
    return true;
  };


  return { reviewCorrection, setReviewCorrection, pricingNotice, setPricingNotice, receiveReview };
}
